import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

import {
    DatiqValidatorsRegisterService,
    DatiqInputErrorTypes,
    DatiqInputValidatorRequiredService,
    DatiqChecklistErrorTypes,
} from '@dat/datiq-components-pkg/utils';
import {
    DatiqChecklistValidatorMaxNumberService,
    DatiqChecklistValidatorMinNumberService,
    DatiqChecklistComponent,
} from './components';
import { DatiqCheckboxModule } from '@dat/datiq-components-pkg/checkbox';

@NgModule({
    declarations: [DatiqChecklistComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatRadioModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        MatInputModule,
        MatFormFieldModule,
        DatiqCheckboxModule,
    ],
    exports: [DatiqChecklistComponent],
})
export class DatiqChecklistModule {
    constructor(
        private _validatorRegistry: DatiqValidatorsRegisterService,
        private _required: DatiqInputValidatorRequiredService,
        private _maxNumber: DatiqChecklistValidatorMaxNumberService,
        private _minNumber: DatiqChecklistValidatorMinNumberService
    ) {
        this._validatorRegistry.register(
            DatiqInputErrorTypes.Required,
            this._required
        );
        this._validatorRegistry.register(
            DatiqChecklistErrorTypes.MaxCheckedItems,
            this._maxNumber
        );
        this._validatorRegistry.register(
            DatiqChecklistErrorTypes.MinCheckedItems,
            this._minNumber
        );
    }
}
